export const primary = '#3bbdb6';
export const lightBlue = '#6ac2bd';
export const lead = '#212121';
export const lightGray = '#f5f5f5';
export const gray = '#999999';
export const red = '#ff0000';
export const dark = '#222';
